import {Component, OnInit, Input, Injector, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NgControl, ControlValueAccessor} from '@angular/forms';
import { Injectable } from '@angular/core';
import { ApiService} from '../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CurrencyService {

    constructor(private api: ApiService) { }

    getCurrencies(): Observable<any> {
        return this.api.get('misc/currencies');
    }
}

const SELECT_CURRENCIES_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectCurrenciesComponent)
};
@Component({
  selector: 'app-select-currencies',
  templateUrl: './select-currencies.component.html',
  styleUrls: ['./select-currencies.component.scss'],
    providers:[SELECT_CURRENCIES_VALUE_ACCESSOR,CurrencyService]
})
export class SelectCurrenciesComponent implements OnInit, ControlValueAccessor {


    _selectedValue: any;

    control: NgControl;

    currencies: Array <any>;

    @Input() id:any;
    @Input() submitted:boolean=false;
    @Input() valueType:string;

    constructor(private currencyService: CurrencyService,
                private  inj: Injector) { }

    ngOnInit() {

        this.currencyService.getCurrencies()
            .subscribe(result =>{
                this.currencies=result;
            });
        this.control = this.inj.get(NgControl);
    }

    //get accessor
    get selectedValue(): any {
        return this._selectedValue; };

    //set accessor including call the onchange callback
    set selectedValue(v: any) {
        this._selectedValue = v;
        this.propagateChange(this._selectedValue);

    }



    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    propagateChange = (_: any) => {};
    onTouched = (_: any) => {};

    //From ControlValueAccessor interface
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._selectedValue = value;
    }



}













// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/select-currencies/select-currencies.component.ts